var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankImageMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_13845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.60661 0.0812744L0.606612 3.08127C0.169112 3.26877 -0.0746379 3.73752 0.0222371 4.20002C0.119112 4.66252 0.525362 5.00002 1.00036 5.00002V5.25002C1.00036 5.66565 1.33474 6.00002 1.75036 6.00002H14.2504C14.666 6.00002 15.0004 5.66565 15.0004 5.25002V5.00002C15.4754 5.00002 15.8847 4.66565 15.9785 4.20002C16.0722 3.7344 15.8285 3.26565 15.3941 3.08127L8.39411 0.0812744C8.14411 -0.0249756 7.85661 -0.0249756 7.60661 0.0812744ZM4.00036 7.00002H2.00036V13.1344C1.98161 13.1438 1.96286 13.1563 1.94411 13.1688L0.444112 14.1688C0.0784871 14.4125 -0.0871379 14.8688 0.0409871 15.2906C0.169112 15.7125 0.559737 16 1.00036 16H15.0004C15.441 16 15.8285 15.7125 15.9566 15.2906C16.0847 14.8688 15.9222 14.4125 15.5535 14.1688L14.0535 13.1688C14.0347 13.1563 14.016 13.1469 13.9972 13.1344V7.00002H12.0004V13H10.7504V7.00002H8.75036V13H7.25036V7.00002H5.25036V13H4.00036V7.00002ZM8.00036 2.00002C8.26558 2.00002 8.51993 2.10538 8.70747 2.29292C8.89501 2.48045 9.00036 2.73481 9.00036 3.00002C9.00036 3.26524 8.89501 3.51959 8.70747 3.70713C8.51993 3.89467 8.26558 4.00002 8.00036 4.00002C7.73515 4.00002 7.48079 3.89467 7.29326 3.70713C7.10572 3.51959 7.00036 3.26524 7.00036 3.00002C7.00036 2.73481 7.10572 2.48045 7.29326 2.29292C7.48079 2.10538 7.73515 2.00002 8.00036 2.00002Z",
    fill: "white",
    fillOpacity: 0.83
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_13845"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankImageMain);
export default __webpack_public_path__ + "static/media/bank-image-main.e6ab6120b2ccb54a63a1a10cd8e92a97.svg";
export { ForwardRef as ReactComponent };